var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartSegmentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.3077,
    y: 1.5,
    width: 3.92308,
    height: 2.61538,
    rx: 0.2,
    transform: "rotate(90 19.3077 1.5)",
    fill: "#899AA3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3846,
    y: 1.5,
    width: 3.92308,
    height: 5.23077,
    rx: 0.2,
    transform: "rotate(90 15.3846 1.5)",
    fill: "#899AA3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.84616,
    y: 1.5,
    width: 3.92308,
    height: 7.84615,
    rx: 0.2,
    transform: "rotate(90 8.84616 1.5)",
    fill: "#899AA3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3077,
    y: 14.5771,
    width: 3.92308,
    height: 2.61538,
    rx: 0.2,
    transform: "rotate(90 19.3077 14.5771)",
    fill: "#899AA3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3846,
    y: 14.5771,
    width: 3.92308,
    height: 2.61538,
    rx: 0.2,
    transform: "rotate(90 15.3846 14.5771)",
    fill: "#899AA3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4615,
    y: 14.5771,
    width: 3.92308,
    height: 10.4615,
    rx: 0.2,
    transform: "rotate(90 11.4615 14.5771)",
    fill: "#899AA3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3077,
    y: 8.03809,
    width: 3.92308,
    height: 5.23077,
    rx: 0.2,
    transform: "rotate(90 19.3077 8.03809)",
    fill: "#899AA3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7692,
    y: 8.03809,
    width: 3.92308,
    height: 6.53846,
    rx: 0.2,
    transform: "rotate(90 12.7692 8.03809)",
    fill: "#899AA3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.92308,
    y: 8.03809,
    width: 3.92308,
    height: 3.92308,
    rx: 0.2,
    transform: "rotate(90 4.92308 8.03809)",
    fill: "#899AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSegmentation);
export default __webpack_public_path__ + "static/media/chart-segmentation.cfe5de5734638b4eb1a78fede1a4b719.svg";
export { ForwardRef as ReactComponent };